import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { showOpenAssignmentModal, hideReport, showReport } from '../../actions/modal';

import ModalContainer from '../modal';
import DefaultLayout from '../../components/layouts/deafult-layout';
import { Body, Heading } from '../../components/typography';
import Spacer from '../../components/spacer';

import { redirectToViewer, getBaseUrl, isTeacher } from '../../lib/utils';
import { GET_ASSIGNMENT_ERROR, getAssignmentByUniqueCode } from '../../actions/assignment';
import { resumeLogin, RESUME_LOGIN_SUCCESS } from '../../actions/auth';
import { generatePayloadForLazeAssignment } from '../../components/modal/bodies/get-user-info/utils';
import ErrorLayout from '../../components/errors';
import { SOURCES } from '../../constants/sources';

const LazeAssignmentPage = ({ getAssignmentByUniqueCode, resumeLogin, isLtiLaunch, source }) => {
    const dispatch = useDispatch();
    const [assignmentDeleted, setAssignmentDeleted] = useState(false);
    const [assignmentTerminated, setAssignmentTerminated] = useState(false);
    const [teacherName, setTeacherName] = useState('');
    const { assignmentUniqueCode } = useParams();

    useEffect(() => {
        const initLazeAssignment = async () => {
            const assignment = await getAssignmentByUniqueCode(assignmentUniqueCode);
            if (assignment.type === GET_ASSIGNMENT_ERROR) {
                return;
            }

            setAssignmentDeleted(assignment.deleted);
            setAssignmentTerminated(assignment.terminated);
            setTeacherName(assignment.teacherName);
            if (assignment.deleted || assignment.terminated) {
                return;
            }

            if (assignment.classId) {
                const { type, payload } = await resumeLogin(source === SOURCES.LAZE && isLtiLaunch);

                if (type === RESUME_LOGIN_SUCCESS) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const payloadViewer = generatePayloadForLazeAssignment(
                        assignment,
                        urlParams.get('from'),
                        isTeacher(payload.data.groupId),
                    );
                    sessionStorage.clear();
                    redirectToViewer(payloadViewer);
                } else {
                    let redirectTo = getBaseUrl();
                    window.location.replace(`${redirectTo}?id=${assignmentUniqueCode}`);
                }
            } else {
                dispatch(showOpenAssignmentModal(assignmentUniqueCode));
            }
        };
        initLazeAssignment();
    }, [dispatch, assignmentUniqueCode, getAssignmentByUniqueCode, resumeLogin, isLtiLaunch]);

    return !assignmentDeleted && !assignmentTerminated ? (
        <DefaultLayout exercises={[]} status={{}} profile={{ status: {} }}>
            <ModalContainer />
        </DefaultLayout>
    ) : (
        <ErrorLayout>
            <Heading lv={3} weight="light">
                {'La prova assegnata non è più disponibile'}
            </Heading>
            <Spacer size="small" />
            <Body>
                <div>
                    {`Questa prova è stata ${assignmentDeleted ? 'eliminata' : 'terminata'} dall'insegnante `}
                    <strong>{`${teacherName}`}</strong>
                </div>
            </Body>
            <Spacer size="medium" />
            <Body>
                {
                    "Non è più possibile svolgere la prova né accedere a correzioni e risultati degli svolgimenti completati. Per maggiori informazioni rivolgiti all'insegnante."
                }
            </Body>
            <Spacer size="medium" />
            <Body>
                {
                    'Hai ancora problemi? Contattaci: descrivi il problema che hai incontrato. Più informazioni potrai darci, meglio potremo aiutarti.'
                }
            </Body>
        </ErrorLayout>
    );
};

LazeAssignmentPage.propTypes = {
    assignmentUniqueCode: PropTypes.string,
    getAssignmentByUniqueCode: PropTypes.func,
    resumeLogin: PropTypes.func,
    displayReport: PropTypes.bool,
    showReport: PropTypes.func,
    hideReport: PropTypes.func,
    isLtiLaunch: PropTypes.bool,
    source: PropTypes.string,
};

const mapStateToProps = (state) => ({
    assignmentUniqueCode: state.modal.assignmentUniqueCode,
    displayReport: state.modal.showReport,
    isLtiLaunch: state.application.isLtiLaunch,
    source: state.application.source,
});

const actionCreators = {
    getAssignmentByUniqueCode,
    resumeLogin,
    hideReport,
    showReport,
};

export default connect(mapStateToProps, actionCreators)(LazeAssignmentPage);
